/** Traduce errores de Supabase/PostgREST/Auth y de /api a un mensaje en español. */
export type ErrorApp = { codigo: string; mensaje: string; original?: unknown };

const MENSAJES: Record<string, string> = {
  NO_AUTENTICADO: "Tu sesión terminó. Vuelve a entrar.",
  VERSION_REQUERIDA: "Falta la versión del aviso de privacidad.",
  SOLO_ADMIN: "Solo un administrador puede hacer esto.",
  FALTA_2FA: "Primero confirma tu verificación en dos pasos.",
  mfa_verification_failed: "El código no es correcto. Usa el de Wealth Nation en tu app y escríbelo antes de que cambie.",
  mfa_challenge_expired: "Se tardó demasiado. Escribe el código que muestra tu app ahora.",
  MENSAJE_AJENO: "Ese mensaje no es tuyo.",
  REPORTE_AJENO: "Ese reporte no es tuyo.",
  MIEMBRO_NO_EXISTE: "No encontré tu cuenta.",
  "42501": "No tienes permiso para hacer eso.",
  PGRST301: "Tu sesión expiró. Vuelve a entrar.",
  PGRST116: "No se encontró el registro.",
  otp_expired: "El código ya venció. Pide uno nuevo.",
  // Supabase devuelve otp_disabled ("Signups not allowed for otp") cuando el correo no existe y las altas están cerradas; el OTP sí está prendido.
  otp_disabled: "Este correo no está en la lista de Wealth Nation. Usa el correo con el que entras a Circle o escríbenos.",
  invalid_credentials: "El código no es correcto.",
  "Token has expired or is invalid": "El código no es correcto o ya venció. Pide uno nuevo.",
  "Signups not allowed for otp": "Este correo no está en la lista de Wealth Nation. Usa el correo con el que entras a Circle o escríbenos.",
  signup_disabled: "Este correo no está en la lista de Wealth Nation. Usa el correo con el que entras a Circle o escríbenos.",
  over_email_send_rate_limit: "Ya te mandamos un código hace poco. Espera un minuto e inténtalo de nuevo.",
  FETCH_FAILED: "Sin conexión. Revisa tu internet e intenta de nuevo.",
};

export function mapearError(error: unknown): ErrorApp {
  if (!error) return { codigo: "DESCONOCIDO", mensaje: "Ocurrió un error." };
  const e = error as { code?: string; message?: string; status?: number; name?: string };
  const message = e.message ?? "";
  if (message.includes("Failed to fetch") || message.includes("NetworkError") || e.name === "TypeError") return { codigo: "FETCH_FAILED", mensaje: MENSAJES.FETCH_FAILED, original: error };
  if (e.code === "P0001") { const codigo = message.trim(); return { codigo, mensaje: MENSAJES[codigo] ?? `Error: ${codigo}`, original: error }; }
  const codigo = e.code ?? (e.status ? String(e.status) : "") ?? "";
  if (codigo && MENSAJES[codigo]) return { codigo, mensaje: MENSAJES[codigo], original: error };
  if (MENSAJES[message]) return { codigo: message, mensaje: MENSAJES[message], original: error };
  return { codigo: codigo || "DESCONOCIDO", mensaje: message || "Ocurrió un error.", original: error };
}
